export default __webpack_public_path__ + "static/media/customize.670f50b7.webp";